
import React, { useEffect } from 'react';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
// import { mainListItems, secondaryListItems } from './listItems';
import ListItems from './ListItems';
import Nav from './Nav'
import api from './../services/axios'

const drawerWidth = 240;


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: '#F2F2F2',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Header() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [dataSaasClient, setDataSaasClient] = React.useState({});
  const [dataSaasClientFilhos, setDataSaasClientFilhos] = React.useState([]);
  const [titleHeader, setTitleHeader] = React.useState('');
  const [listItemsData, setListItemsData] = React.useState([]);

  const logout = () => {
    localStorage.setItem('token', '');
    window.location = `/login`;
  }

  // const loadData = async () => {

  //   const data = await api.get('/v1/saas/me')
  //   let saasClientMe = data.data.data;

  //   const saasClientId = localStorage.getItem('saasClientId')
    
  //   let excludeId=false;
  //   let dataSaasClientActive={};
  //   if(saasClientId){
  //     const data = await api.get('/v1/saas/'+saasClientId)
  //     setDataSaasClient(data.data)
  //     dataSaasClientActive=data.data
  //     excludeId=saasClientId
  //   }else{
  //     setDataSaasClient(saasClientMe)
  //     dataSaasClientActive=saasClientMe
  //     excludeId=saasClientMe.id
  //   }
  
  //   let dataFilhos = await api.get('/v1/saas/')
  //   dataFilhos = [...dataFilhos.data.data, ...[saasClientMe]]
  //   dataFilhos = dataFilhos.filter((d)=>parseInt(d.id)!==parseInt(excludeId))

  //   setDataSaasClientFilhos(dataFilhos)

  //   setTitleHeader(dataSaasClientActive.name)
  //   setListItemsData(dataFilhos)
  // }


  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerMenu = () => {
    setOpen(!open);
  };
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  return (
    <>
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Nav  
          handleDrawerMenu={handleDrawerMenu} 
          logoutAction={logout} 
          titleHeader={titleHeader}  
          />
        {/* <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
          >
            <MenuIcon />
          </IconButton>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            {titleHeader}
          </Typography>
          <IconButton color="inherit">
            <Badge badgeContent={4} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Toolbar> */}
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon} >
          <IconButton onClick={handleDrawerMenu}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List><ListItems titleHeader={titleHeader} data={listItemsData} /></List>
      </Drawer>
    </>
  )
}